<div bsModal #helpModal="bs-modal" class="modal fade" role="dialog">
  <div class="modal-help">
    <div class="modal-dialog">
      <div class="modal-content" #helpFrame>
      </div>
    </div>
  </div>
</div>
